import { ApiProperty } from "@nestjs/swagger";

export class DatesDto {
    @ApiProperty()
    fromDate: Date;

    @ApiProperty()
    toDate: Date;

    @ApiProperty()
    budgetType: string;
    @ApiProperty()
    department?: number;

}